import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { getCustomerComplaints } from 'redux/actions/CustomerComplaints';
import { dateFormate } from 'utils/utils';

const BillingDisputeCard = (props) => {
  const { tableData, onUpdateComplaint } = props;
  const dispatch = useDispatch();
  const [modalState, setModalState] = useState({ show: false, actionType: '' });
  const [actionReason, setActionReason] = useState('');

  const openModal = (actionType) => {
    setModalState({ show: true, actionType });
    setActionReason('');
  };

  const closeModal = () => {
    setModalState({ show: false, actionType: '' });
    setActionReason('');
  };

  const handleSubmit = async () => {
    if (!actionReason.trim()) {
      toast.warning('Please provide a reason.');
      return;
    }

    onUpdateComplaint(tableData?.id, modalState.actionType, actionReason);
    closeModal();
    setTimeout(() => {
      dispatch(getCustomerComplaints({ id: tableData?.id }));
    }, 2000);
  };

  const handleInReview = async () => {
    onUpdateComplaint(tableData?.id, 'In Review', '');
    setTimeout(() => {
      dispatch(getCustomerComplaints({ id: tableData?.id }));
    }, 2000);
  };

  const isDisabled = tableData?.status === 'Rejected' || tableData?.status === 'Resolved';

  return (
    <>
      <div className="card mt-8">
        <div className="card-header">
          <div className="trip-details">
            <div className="detail-badge">Trip ID: {tableData?.tripId}</div>
            <div className="detail-badge">
              {dateFormate(tableData?.createdAt, 'DD MMMM YYYY, hh:mm a')}
            </div>
            <div className="detail-badge">Ticket ID: {tableData?.complainId}</div>
          </div>
          <div className="status-section">
            <span className="status-label">Current Status:</span>
            <span className="status-badge">{tableData?.status}</span>
          </div>
        </div>

        <div className="main-content">
          {tableData?.complainType === 'sos' ? (
            // --- SOS Alert Section ---
            <div>
              <h1 className="mb-4 text-[24px] font-bold text-[#252525]">SOS Alert</h1>

              <div className="flex flex-wrap gap-4 mb-4">
                {/* Driver Info */}
                <div className="bg-[#EDF5FD] rounded-[8px] p-4 flex-1 min-w-[250px]">
                  <div className="text-[16px] font-bold text-black mb-2">Driver Info</div>
                  <div className="text-[14px] text-black font-semibold leading-[24px]">
                    Driver:
                    <span className="text-[14px] text-[#4D4D4D] font-normal ml-1">
                      {tableData?.additionalInfo?.driverInfo?.name}
                    </span>
                  </div>
                  <div className="text-[14px] text-black font-semibold leading-[24px]">
                    Vehicle Number:
                    <span className="text-[14px] text-[#4D4D4D] font-normal ml-1">
                      {tableData?.additionalInfo?.driverInfo?.vehicleNumber}
                    </span>
                  </div>
                  <div className="text-[14px] text-black font-semibold leading-[24px]">
                    Driver Contact:
                    <span className="text-[14px] text-[#4D4D4D] font-normal ml-1">
                      {tableData?.additionalInfo?.driverInfo?.phone}
                    </span>
                  </div>
                </div>

                {/* Emergency Contact */}
                <div className="bg-[#EDF5FD] rounded-[8px] p-4 flex-1 min-w-[250px]">
                  <div className="text-[16px] font-bold text-black mb-2">Emergency Contact</div>

                  {['contact1', 'contact2'].map((key, index) => (
                    <div key={key} className="text-[14px] text-black font-semibold leading-[24px]">
                      Contact {index + 1}:
                      <span className="text-[14px] text-[#4D4D4D] font-normal ml-1">
                        {tableData?.additionalInfo?.customerEmergencyContact?.[key] || '--'}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Public Emergency Line */}
                <div className="bg-[#EDF5FD] rounded-[8px] p-4 flex-1 min-w-[250px]">
                  <div className="text-[16px] font-bold text-black mb-2">Public emergency line</div>
                  <div className="text-[14px] text-black font-semibold leading-[24px]">
                    Police:
                    <span className="text-[14px] text-[#4D4D4D] font-normal ml-1">
                      {tableData?.additionalInfo?.publicHelpLine?.police}
                    </span>
                  </div>
                  <div className="text-[14px] text-black font-semibold leading-[24px]">
                    Ambulance:
                    <span className="text-[14px] text-[#4D4D4D] font-normal ml-1">
                      {tableData?.additionalInfo?.publicHelpLine?.ambulance}
                    </span>
                  </div>
                </div>
              </div>

              {/* Location Details */}
              <div className="bg-[#EDF5FD] rounded-[8px] p-4 mb-4">
                <div className="text-[16px] font-bold text-black mb-2">Location Details</div>
                <div className="text-[14px] text-black font-semibold leading-[24px]">
                  Raised Location:
                  <span className="text-[14px] text-[#4D4D4D] font-normal ml-1">
                    {tableData?.additionalInfo?.locationDetails?.sosAddress}
                  </span>
                </div>
                <div className="text-[14px] text-black font-semibold leading-[24px] mb-[10px]">
                  Lat log:
                  <span className="text-[14px] text-[#4D4D4D] font-normal ml-1">
                    {tableData?.additionalInfo?.locationDetails?.coordinates
                      ? `${tableData.additionalInfo.locationDetails.coordinates[0]}°N, ${tableData.additionalInfo.locationDetails.coordinates[1]}°`
                      : ''}
                  </span>
                </div>

                <a
                  href={tableData?.additionalInfo?.locationDetails?.trackTripLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="justify-center items-center gap-[10px] px-[16px] py-[8px] border border-[color:var(--brand-primary)] text-[color:var(--brand-primary)] text-[14px] leading-[24px] rounded"
                >
                  View Live tracking
                </a>
              </div>
            </div>
          ) : (
            <>
              <h1 className="title">{tableData?.title}</h1>
              <p className="description">{tableData?.description}</p>
            </>
          )}
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button
            className={`btn btn-reject ${isDisabled ? 'btn-disabled' : ''}`}
            onClick={() => openModal('Rejected')}
            disabled={isDisabled}
          >
            Reject
          </button>
          <button
            className={`btn ${isDisabled ? 'btn-disabled' : ''}`}
            onClick={handleInReview}
            disabled={isDisabled}
          >
            In Review
          </button>
          <button
            className={`btn btn-approve ${isDisabled ? 'btn-disabled' : ''}`}
            onClick={() => openModal('Resolved')}
            disabled={isDisabled}
          >
            Resolved
          </button>
        </div>
      </div>

      {modalState.show && (
        <div className="modal-overlay">
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                Provide a reason for{' '}
                {modalState.actionType === 'Rejected'
                  ? 'rejection'
                  : modalState.actionType === 'Resolved'
                    ? 'approval'
                    : modalState.actionType.toLowerCase()}
                .
              </h3>
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
            </div>
            <textarea
              className="textarea"
              placeholder="Type reason here"
              value={actionReason}
              onChange={(e) => setActionReason(e.target.value)}
            />
            <div className="modal-actions">
              <button className="submit-button" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default BillingDisputeCard;
